import axios from 'axios';
import apiConfig from '../../api.config';

export default function updatePoliceMOSSOS({
  hotelId,
  body,
}) {
  const {
    host,
    URIs: { policeReport, policeReportMOSSOS },
  } = apiConfig;

  const uri = `${host}${policeReport}/${policeReportMOSSOS.replace(':hotelId', hotelId)}`;

  return axios
    .put(uri, body, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
